




document.addEventListener('DOMContentLoaded', () => {

    const
        url = new URL(window.location.href),
        params = new URLSearchParams(url.search);

    if (_.isNull(params.get('country')) && url.pathname === '/prodejny') {
        const country = ID['sallers-country'].dataset.country;
        if (!_.isUndefined(country)) {
            naja.makeRequest('POST', country, null, {history: true, spinner: false});

        }

    }

    const sellerMapEl = document.getElementById('detail-map');
    if (!_.isNull(sellerMapEl)) {
        var m = new SMap(sellerMapEl);
        m.addControl(new SMap.Control.Sync());
        m.addDefaultLayer(SMap.DEF_BASE).enable();
        m.addDefaultControls();

        var query = sellerMapEl.dataset.street + ' ' + sellerMapEl.dataset.city;

        new SMap.Geocoder(query, odpoved);

        function odpoved(geocoder) {

            var vysledky = geocoder.getResults()[0].results;

            var data = [];
            while (vysledky.length) { /* Zobrazit všechny výsledky hledání */
                var item = vysledky.shift()
                data.push(item.coords.toWGS84());
            }

            var center = SMap.Coords.fromWGS84(data[0][0], data[0][1]);
            var m = new SMap(sellerMapEl, center, 13);
            m.addDefaultLayer(SMap.DEF_BASE).enable();
            m.addDefaultControls();

            var layer = new SMap.Layer.Marker();
            m.addLayer(layer);
            layer.enable();

            var card = new SMap.Card();
            card.getHeader().innerHTML = "<strong>" + sellerMapEl.dataset.title + "</strong>";
            card.getBody().innerHTML = sellerMapEl.dataset.street + '<br>' + sellerMapEl.dataset.city;

            var options = {
                title: sellerMapEl.dataset.title
            };
            var marker = new SMap.Marker(center, "myMarker", options);
            marker.decorate(SMap.Marker.Feature.Card, card);
            layer.addMarker(marker);
        }

    }

    FNP.salles.initMap();

});

FNP.sallers.sendCountryForm = async form => {
    await naja.uiHandler.submitForm(form);
}

FNP.salles.initMap = function () {

    const mapImg = ID['map-img'];

    [...document.getElementsByClassName('map-area')].forEach(el => {
        el.addEventListener('mouseenter', () => {
            mapImg.src = el.dataset.img;
            mapImg.style.display = 'none';
            mapImg.style.transition = 'opacity 0s';
            mapImg.style.opacity = '0';
            mapImg.style.display = 'block';
            setTimeout(function() {
                mapImg.style.transition = 'opacity 0.5s';
                mapImg.style.opacity = '1';
            }, 0);
        });

        el.addEventListener('mouseleave', () => {
            mapImg.src = '/assets/img/maps/none.png';
            mapImg.style.display = 'block';
        });

        el.addEventListener('click', () => {
            naja.makeRequest('GET', el.dataset.link, null, {history: true});
        })

    });

}

naja.addEventListener('success', () => {
    FNP.salles.initMap()
})
